import React from 'react';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { Box, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';
import { accountStore, setAccountLinkListDialogOpen, submitLogoutAsync } from 'features/account/stores/account.slice';
import 'features/account/styles/Account.scss';
import CommonDialog from 'components/CommonDialog';
import { PROFILE_CATEGORY_LIST } from 'features/profile/config/profile-form.const';

const AccountLinkListDialog = () => {
   const dispatch = useAppDispatch();
   const { referralCode, rewards, accountLinkListDialogOpen } = useAppSelector(accountStore);

   const filteredProfileCategoryList = PROFILE_CATEGORY_LIST.filter((category) => {
      return (
         ![7, 8].includes(category.value) ||
         (category.value === 7 && referralCode?.code) ||
         (category.value === 8 && rewards?.account)
      );
   });

   const handleClose = () => {
      dispatch(setAccountLinkListDialogOpen(false));
   };

   const handleListItemClick = (route: string) => {
      if (route === 'signout') {
         dispatch(
            submitLogoutAsync({
               bodyInput: {
                  allSessions: true,
               },
            }),
         );
         handleClose();
      } else {
         window.location.href = `/user#${route}`;
         handleClose();
      }
   };

   return (
      <CommonDialog
         open={accountLinkListDialogOpen}
         title="Mange your account"
         onClose={handleClose}
         isLoading={false}
         onSubmit={handleClose}
         submitLabel="Close"
      >
         <Box sx={{ width: '100%' }}>
            <nav>
               <List>
                  {filteredProfileCategoryList.map((profileItem, itemIdx) => {
                     return (
                        <ListItem key={`link-item-${itemIdx}`} disablePadding>
                           <ListItemButton onClick={() => handleListItemClick(profileItem.route)}>
                              <ListItemIcon>{profileItem.icon}</ListItemIcon>
                              <ListItemText primary={profileItem.name} />
                           </ListItemButton>
                        </ListItem>
                     );
                  })}
               </List>
            </nav>
         </Box>
      </CommonDialog>
   );
};

export default AccountLinkListDialog;
